module.exports = "/static-assets/_next/static/images/bananaRat-918f6b865b1303ffa373deeea9026847.png";